import React, {Component} from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import AssignmentList from './components/Assignment/AssignmentList'

import {
  fetchAssignments
} from 'broker/redux/assignment'

import {
  fetchSlimAccount
} from 'broker/redux/account'

import { UNIVERSAL_EXPORT_TIMEFRAME_MONTH } from 'common/constants'
import {getAuthEmail} from "broker/util/downloader";

const mapDispatchToProps = dispatch => ({
    dispatch
})

class AssignmentContainer extends Component {

    componentDidMount() {
      const { dispatch, assignment, location } = this.props

      const initialStateAgentId = _.get(location, ['state', 'agentId'])

      if (!initialStateAgentId) {
        dispatch(fetchAssignments(UNIVERSAL_EXPORT_TIMEFRAME_MONTH))
      }
      dispatch(fetchSlimAccount())
    }

    render() {
      return <AssignmentList {...this.props} />
    }
}

export default connect((state) => ({ assignment: state.assignment, account: state.account, email: getAuthEmail(state), auth: state.auth, root: state.root }), mapDispatchToProps)(AssignmentContainer)
